// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-calendar[data-v-286bd6ac]{width:100%}.vc-container[data-v-286bd6ac]{border:0}.date-circle[data-v-286bd6ac]{background:#ff8080}.date-text[data-v-286bd6ac]{color:#000}.vc-container .vc-header[data-v-286bd6ac]{background-color:red;padding:10px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
